// extracted by mini-css-extract-plugin
module.exports = {"container":"F5CvG","mobile":"_3JPrz"};